import styled from '@emotion/styled'

export const StyledContainer = styled.div`
  z-index: 9999;
  background: rgba(0, 0, 0, 0.9);
  .pre-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #636363;
    z-index: 2000;
  }
`
export const StyledHeader = styled.div`
  padding: 0 40px;
  background: rgba(0, 0, 0, 0.9);
  .title {
    margin: 0;
  }
  .close {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
  }
`

export const StyledFile = styled.div`
  height: calc(100% - 4rem);
  .disabled-show {
    width: 105px;
    height: 105px;
  }
  .disabled-show-text {
    margintop: 40px;
    fontsize: 16px;
    width: 208px;
    height: 36px;
    border: 1px solid #fff;
    borderradius: 19px;
    color: #fff;
  }
`
